const aws_config = {
  aws_project_region: "us-east-1", // Replace with your bucket's region
  Auth: {
    // identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID,
    region: process.env.REACT_APP_AWS_REGION,
    userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "CubexApiGateWay",
        endpoint: process.env.REACT_APP_AWS_API_GATEWAY_URL,
      },
      {},
    ],
  },
  Storage: {
    AWSPublicS3: {
      bucket: process.env.REACT_APP_AWS_PUBLIC_S3_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    },
    AWSProtectedS3: {
      bucket: process.env.REACT_APP_AWS_PROTECTED_S3_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    },
    AWSPrivateS3: {
      bucket: process.env.REACT_APP_AWS_PRIVATE_S3_BUCKET,
      region: process.env.REACT_APP_AWS_REGION,
    },
  },
};

export default aws_config;
